export const css = {
	root: '_3OJjzpl2',
	' _key': 'ascm-theme/ascm/variants/cltd'
};

export default css;
